(() => {
  const dialog = document.getElementById('expo-popup');
  if (!dialog) return;
  const expiry = Date.parse(dialog.dataset.expires);
  if (!Number.isFinite(expiry) || Date.now() >= expiry) return;
  const key = 'limelight-ottawa-expo-2026-booth-226-v2';
  try { if (sessionStorage.getItem(key) === '1') return; } catch (_) {}
  let previousFocus;
  let previousOverflow = '';
  const focusable = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const dismiss = () => {
    if (dialog.hidden) return;
    dialog.hidden = true;
    dialog.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = previousOverflow;
    document.removeEventListener('keydown', onKeydown);
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  };
  const onKeydown = event => {
    if (event.key === 'Escape') {
      event.preventDefault();
      dismiss();
      return;
    }
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll(focusable)].filter(el => !el.hidden);
    if (!controls.length) return;
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };
  dialog.querySelectorAll('[data-expo-close], [data-expo-link]').forEach(el => el.addEventListener('click', dismiss));
  dialog.addEventListener('click', event => {
    if (event.target === dialog) dismiss();
  });
  window.setTimeout(() => {
    if (Date.now() >= expiry) return;
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    dialog.hidden = false;
    dialog.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeydown);
    const closeButton = dialog.querySelector('[data-expo-close]');
    if (closeButton) closeButton.focus({ preventScroll: true });
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
  }, 400);
})();
